import type { CalendarComposeInitializationConfig } from 'owa-calendar-helpers-types/lib/CalendarComposeInitializationConfig';
import isEntrySourceUndo from '../../utils/isEntrySourceUndo';
import { dismissUndoNotification } from 'owa-calendar-actions';
import EventScope from 'owa-service/lib/contract/EventScope';
import { initializeEventsForEdit } from '../../utils/initializeEventsForEdit';
import { addComposeStore, setOriginalEvent, setEvent } from 'owa-calendar-compose-store-manager';
import { handleComposePopoutForMeetingDraft } from 'owa-calendar-compose-form-actions';
import showFullCompose from './showFullCompose';

export async function showFullComposeToEdit(
    formId: string,
    config: CalendarComposeInitializationConfig
): Promise<string | null> {
    const entrySource = config.fullComposeEntrySource || 'Edit';

    // If the form's entry source is undo, the notification is dismissed when the undo button is
    // selected. In all other cases, we dismiss the notification manually
    if (!isEntrySourceUndo(entrySource)) {
        dismissUndoNotification();
    }

    const fetchSource = 'FullComposeInEditMode_' + config.fullComposeEntrySource;

    const { originalEvent, event, createCollabSpaceOnInitProps } = await initializeEventsForEdit(
        fetchSource,
        config.eventScope ?? EventScope.Default,
        config.eventUpdates?.ItemId ?? undefined,
        config.eventUpdates,
        config.itemHasUpdates,
        config.shouldInitializeForNewDraft ||
            config.shouldRespectStartEndTime /* shouldRespectStartEndTime */
    );

    if (!originalEvent || !event) {
        // TODO: Graceful error handling when the event is not found
        // https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/119628
        return null;
    }

    addComposeStore(formId);

    setOriginalEvent(formId, originalEvent);
    setEvent(formId, event);

    if (config.shouldInitializeForNewDraft) {
        // Must be called after setting up originalEvent and event in the store
        handleComposePopoutForMeetingDraft(formId);
    }

    const collabSpaceProps = createCollabSpaceOnInitProps || config.createCollabSpaceOnInitProps;

    await showFullCompose(
        event.CharmId != 0 /* isCharmExplicitlySet */,
        entrySource,
        config.viewType,
        config.shouldOpenSchedulingAssistant,
        config.extractionSourceId,
        config.internetMessageId,
        collabSpaceProps,
        formId
    );

    return formId;
}
